import fancybox from '@fancyapps/fancybox';

$(".lightboxGallery__item").fancybox({
    arrows: true
});